import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import RestrictPath from '../shared/user/RestrictPath';
import { overrideFiltersAction } from '../store/resources';
import changelog from './changelog';

const firstNameOf = (user) => {
  if (!user) {
    return '';
  }
  return user.firstname || (user.display_name || '').split(' ')[0] || '';
};

const WhatsNewCard = () => {
  const release = changelog[0];
  if (!release) {
    return null;
  }

  return (
    <div className="card h-100">
      <div className="card-body p-4">
        <h6 className="text-muted">Wat is nieuw</h6>
        <h4 className="card-title">{release.version}</h4>
        <ul className="whats-new-list">
          {release.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const WelcomePosterView = ({ user, filterOnOpenActions }) => {
  const firstName = firstNameOf(user);

  return (
    <div className="container-fluid card-oversized welcome-poster-container my-5">
      <div className="row">
        <div className="col-lg-8 mb-4 mb-lg-0">
          <div className="card welcome-poster h-100">
            <div className="card-body">
              <h5 className="welcome-poster-brand mb-3 text-muted">Aspire ATS</h5>
              <h1 className="welcome-poster-title">
                Welcome {firstName},
                <br />
                what&apos;s your team aspiration?
              </h1>
              <p className="welcome-poster-subtitle">
                Alles wat actie nodig heeft staat voor je klaar onder 'Sollicitanten'.
            </p>
              <RestrictPath path="employees">
                <Link
                  to="/applicants/"
                  className="btn btn-dark btn-lg"
                  onClick={filterOnOpenActions}
                >
                  <i className="fa fa-certificate mr-1" /> Alle open acties
                </Link>
              </RestrictPath>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <WhatsNewCard />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

// The applicants grid fetches with whatever filters are in the store when it
// mounts, so setting them here is enough — no extra fetch needed.
const mapDispatchToProps = (dispatch) => ({
  filterOnOpenActions: () =>
    dispatch(overrideFiltersAction('applicants', { record_status: 'Open' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePosterView);
